module.exports = __webpack_public_path__ + "static/media/bq_mobility_large.648f6bbd.png";